"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _GSemployeeRole = _interopRequireDefault(require("../../../SIA-WEBSITE/GSemployeeRole/GSemployeeRole"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.jury-container .bottom-section {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  width: 100%;\n  justify-content: flex-start;\n  column-gap: 16px; }\n\n.jury-container .info-container {\n  margin-left: 0px; }\n\n@media (max-width: 66rem) {\n  .jury-container {\n    padding-inline: 16px; }\n    .jury-container .bottom-section {\n      grid-template-columns: repeat(3, minmax(0, 1fr)); }\n    .jury-container .info-container {\n      width: 100%;\n      max-width: 312px; } }\n\n@media (max-width: 42rem) {\n  .jury-container {\n    padding-inline: 16px; }\n    .jury-container .bottom-section {\n      grid-template-columns: repeat(2, minmax(0, 1fr)); }\n    .jury-container .info-container {\n      width: 100%;\n      max-width: 288px; } }\n";
  const fileName = "JuryList_JuryList";
  const element = document.querySelector("style[data-sass-component='JuryList_JuryList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const formatItems = data => {
  return data.map(item => {
    return {
      id: item.id,
      firstname: item.title,
      lastname: item.lastname,
      email: item.email,
      picture: item.image || undefined,
      gender: item.gender,
      professional_function: item.function || '',
      diploma_title: item.professional_title,
      website: item.jury_member_url?.original_url
    };
  });
};
const JuryList = _ref => {
  let {
    data
  } = _ref;
  const [items, setItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (data) {
      const data_formatted = formatItems(data);
      setItems(data_formatted);
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "jury-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-section"
  }, items.map(employee => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "employee",
      key: employee.id
    }, /*#__PURE__*/_react.default.createElement(_GSemployeeRole.default, employee));
  })));
};
var _default = exports.default = JuryList;